app.config(['$routeProvider', '$locationProvider', function($routeProvider, $locationProvider) {

    // MAIN APP
    $routeProvider
        .when('/', {
            templateUrl: 'views/landing-page.html',
            controller: 'LandingPageController'
        })
    	.when('/send-gift-to/:username', {
            templateUrl: 'views/landing-page.html',
            controller: 'LandingPageController'
        })
        .when('/send-gift-to/:username/:time', {
            templateUrl: 'views/landing-page.html',
            controller: 'LandingPageController'
        })
        /*.when('/login', {
            templateUrl: 'views/login.html',
            controller: 'LoginController'
        })*/
        .when('/logout', {
            template: '',
            controller: 'LogoutController'
        })
        /*.when('/register', {
            templateUrl: 'views/register.html',
            controller: 'RegisterController'
        })*/
        // Card #806: Multi-Currency / Multi-Gateway Feature
        /*.when('/select-user/:next_page', {
            templateUrl: 'views/select-user.html',
            controller: 'SelectUserController'
        })*/
        .when('/venues', {
            templateUrl: 'views/venues.html',
            controller: 'VenuesController'
        })
        .when('/menu', {
            templateUrl: 'views/menu.html',
            controller: 'MenuController'
        })
        .when('/drink-cart', {
            templateUrl: 'views/drink-cart.html',
            controller: 'DrinkCartController'
        })
        .when('/money-cart', {
            templateUrl: 'views/money-cart.html',
            controller: 'MoneyCartController'
        })
        .when('/money-credit-card-payment', {
            templateUrl: 'views/money-credit-card-payment.html',
            controller: 'MoneyCreditCardPaymentController'
        })
        .when('/drink-credit-card-payment', {
            templateUrl: 'views/drink-credit-card-payment.html',
            controller: 'DrinkCreditCardPaymentController'
        })
        .when('/select-money-amount', {
            templateUrl: 'views/select-money-amount.html',
            controller: 'SelectMoneyController'
        })
        .when('/drink-receipt', {
            templateUrl: 'views/drink-receipt.html',
            controller: 'DrinkReceiptController'
        })
        .when('/money-receipt', {
            templateUrl: 'views/money-receipt.html',
            controller: 'MoneyReceiptController'
        })
        .when('/invite/:code', {
            templateUrl: 'views/register_by_invite.html',
            controller: 'RegisterByInviteController'
        })
        .when('/register', {
            templateUrl: 'views/cognito/register.html',
            controller: 'CognitoRegisterController'
        })
        .when('/login', {
            templateUrl: 'views/cognito/login.html',
            controller: 'CognitoLoginController'
        })
        .when('/update-password', {
            templateUrl: 'views/cognito/update-password.html',
            controller: 'CognitoLoginController'
        })
        .otherwise({
            redirectTo: '/'
        });


    // TICKETED EVENT
    $routeProvider
        .when('/tickets/:event_name', {
            templateUrl: 'views/ticketed_event/landing-page.html',
            controller: 'TicketedEventLandingPageController'
        })
        .when('/tickets/:event_name/select-tickets', {
            templateUrl: 'views/ticketed_event/select-tickets.html',
            controller: 'TicketedEventSelectTicketsController'
        });

    //.when('/ticketing/:event_name/event', {
    //    templateUrl: 'views/ticketed_event/landing-page.html',
    //    controller: 'TicketedEventLandingPageController'
    //})
    //    .when('/ticketing/:event_name/event/select-tickets', {
    //        templateUrl: 'views/ticketed_event/select-tickets.html',
    //        controller: 'TicketedEventSelectTicketsController'
    //    });

    $locationProvider.html5Mode(true);
}]);